<template>

  <el-row class="tac">
    <el-col :span="24">
      <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          active-text-color="#ffd04b"
          background-color="#545c64"
          text-color="#fff"
      >

        <el-menu-item index="1" @click="router.push('/ziyuan')">
          <el-icon><setting /></el-icon>
          <span >资源列表</span>
        </el-menu-item>
      </el-menu>
    </el-col>

  </el-row>
</template>

<script  setup>
import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
} from '@element-plus/icons-vue'
import router from "@/router";
const handleOpen = (key, keyPath) => {
  console.log(key, keyPath)
}
const handleClose = (key, keyPath) => {
  console.log(key, keyPath)
}
</script>
